package br.com.htms.inspeccaocampo.data

import br.com.htms.inspeccaocampo.platform.currentTimeMillis
import br.com.htms.inspeccaocampo.platform.formatDateBr

enum class CaracterizacaoOcorrencia(val rotulo: String) {
    OCORRENCIA("OCORRÊNCIA"),
    INCIDENTE("INCIDENTE"),
    ACIDENTE_AMBIENTAL("ACIDENTE AMBIENTAL"),
    ACIDENTE_SEM_AFASTAMENTO("ACIDENTE SEM AFASTAMENTO"),
    ACIDENTE_COM_AFASTAMENTO("ACIDENTE COM AFASTAMENTO"),
    ACIDENTE_DANOS_MATERIAIS("ACIDENTE C/ DANOS MATERIAIS");

    companion object {
        fun fromName(raw: String?): CaracterizacaoOcorrencia? =
            raw?.takeIf { it.isNotBlank() }?.let { runCatching { valueOf(it) }.getOrNull() }
    }
}

enum class TipoOcorrencia(val rotulo: String) {
    TIPICO("TÍPICO"),
    TRAJETO("TRAJETO");

    companion object {
        fun fromName(raw: String?): TipoOcorrencia? =
            raw?.takeIf { it.isNotBlank() }?.let { runCatching { valueOf(it) }.getOrNull() }
    }
}

enum class ClasseEventoOcorrencia(val rotulo: String) {
    CLASSE_0("Classe 0 : Desvio / Condição Insegura"),
    CLASSE_1("Classe 1 : Quase Acidente"),
    CLASSE_2("Classe 2 : Incidente com Dano Material ou Ambiental"),
    CLASSE_3("Classe 3 : Acidente com Lesão Leve"),
    CLASSE_4("Classe 4 : Acidente Grave"),
    CLASSE_5("Classe 5 : Acidente Gravíssimo/Fatal");

    companion object {
        fun fromName(raw: String?): ClasseEventoOcorrencia? =
            raw?.takeIf { it.isNotBlank() }?.let { runCatching { valueOf(it) }.getOrNull() }
    }
}

data class FormComunicacaoOcorrencias(
    val cliente: String = "",
    val obra: String = "",
    val caracterizacao: CaracterizacaoOcorrencia? = null,
    val tipo: TipoOcorrencia? = null,
    val dataHoraOcorrido: String = "",
    val localExato: String = "",
    val quemReportando: String = "",
    val tipoEvento: ClasseEventoOcorrencia? = null,
    val envolvidoNome: String = "",
    val envolvidoFuncao: String = "",
    val responsavelAtividade: String = "",
    val responsavelCargo: String = "",
    val responsavelEstavaNoLocal: RespostaSimNao? = null,
    val dataAcidente: String = "",
    val horaAcidente: String = "",
    val horasTrabalhadas: String = "",
    val localAcidente: String = "",
    val parteCorpoLesionada: String = "",
    val agenteCausador: String = "",
    val naturezaLesao: String = "",
    val acoesTomadasImediato: String = "",
    val descricaoEvento: String = "",
    val fotos: List<FotoAnexo> = emptyList(),
    val dataHorarioMs: Long = currentTimeMillis(),
    val latitude: Double? = null,
    val longitude: Double? = null,
    val localTexto: String = ""
) {
    fun dataHorarioFormatado(): String = formatDateBr(dataHorarioMs)

    fun linkGoogleMaps(): String? {
        val lat = latitude ?: return null
        val lng = longitude ?: return null
        return "https://maps.google.com/?q=$lat,$lng"
    }

    fun fotosParaExportacao(): List<Pair<String, FotoAnexo>> =
        fotos.mapIndexed { index, foto -> "Fotos — Foto ${index + 1}" to foto }
}

fun FormComunicacaoOcorrencias.semConteudoBase64(): FormComunicacaoOcorrencias = copy(
    fotos = fotos.map { it.copy(conteudoBase64 = null) }
)

fun FormComunicacaoOcorrencias.temConteudoRascunho(): Boolean =
    cliente.isNotBlank() ||
        obra.isNotBlank() ||
        caracterizacao != null ||
        tipo != null ||
        dataHoraOcorrido.isNotBlank() ||
        localExato.isNotBlank() ||
        quemReportando.isNotBlank() ||
        tipoEvento != null ||
        envolvidoNome.isNotBlank() ||
        envolvidoFuncao.isNotBlank() ||
        responsavelAtividade.isNotBlank() ||
        responsavelCargo.isNotBlank() ||
        responsavelEstavaNoLocal != null ||
        dataAcidente.isNotBlank() ||
        horaAcidente.isNotBlank() ||
        horasTrabalhadas.isNotBlank() ||
        localAcidente.isNotBlank() ||
        parteCorpoLesionada.isNotBlank() ||
        agenteCausador.isNotBlank() ||
        naturezaLesao.isNotBlank() ||
        acoesTomadasImediato.isNotBlank() ||
        descricaoEvento.isNotBlank() ||
        fotos.isNotEmpty()
